import React from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import { QRCodeCanvas } from "qrcode.react";
import { getcolor } from "./UnderHeaderCom";

const UnderHeaderComTow = (props) => {

  const {locInv, found, inv, sta ,premiApp} = props;
  const clasm = useInvMain();
  const clas = useInvAF();
  const invColors = sta?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  const styfCenter = { fontWeight: "bold", maxHeight: "1rem", minHeight: "1rem", color: "#000" };

  const styleSq = {
    backgroundColor: secondColor, fontWeight: "bold", fontSize: "1rem",
    color: "#000", border: "solid 0.1px", borderColor: "#000", borderRadius: "6px",
    padding: 5,
  }

  return (
    <Grid
      item
      container
      style={{
        fontWeight: "bold", fontFamily: "Amiri-Regular",
        marginLeft: "0cm", marginRight: "0rem", paddingTop: "0.5rem"
      }}
    >
      <Grid item xs={12}>

        <Grid item container >
          <Grid item container style={{ direction: "rtl" }}>
            <Grid item xs={3} style={{ fontFamily: "Amiri-Regular" }}
            >
              <Grid item container className={clasm.mincntr}>
                <Grid item xs={12} >
                  {inv.tax > 0 && locInv.ProcTypeInvProc !== "22" &&  locInv.ProcTypeInvProc !== "03"&& locInv.ProcTypeInvProc !== "04"&& (
                    <Grid item xs={12}>
                      {(locInv?.Step_inv2 && sta.tot?.ZatcaQR) ? (
                        <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                          {
                            <QRCodeCanvas value={sta.tot?.ZatcaQR} />
                          }

                        </ButtonBase>
                      )
                        : (
                          <ButtonBase
                            style={{ border: "solid 1px" }}
                          >
                            {
                              <img
                                src={`data:image/jpeg;base64,${inv.qr_image}`}
                                style={{ height: 150, width: 150, margin: 0, padding: 0 }}
                                alt={found.nameA}
                              />
                            }
                          </ButtonBase>
                        )}

                    </Grid>
                  )}
                </Grid>

              </Grid>
            </Grid>
            <Grid item xs={9}

            >
              <Grid item container className={clasm.mincntr}>
                <Grid item container style={{ paddingBottom: "0.3rem" }}>
                  {inv.tax > 0 && (
                    <Grid item xs={8}>
                      <div style={styleSq}>
                        {sta.tot.tax_no_cust === ""
                          ? "فاتورة ضريبية مبسطة" + " " + "Simplified Tax Invoice"
                          : "فاتورة ضريبية" + " " + "Tax Invoice"}
                      </div>
                      <div style={{ paddingTop: 5 }}></div>
                    </Grid>
                  )}
                  <Grid item xs={4}></Grid>
                  <Grid item xs={8} style={styleSq} >
                    {premiApp.billTemplate === 21 ?
                      (
                        locInv.invN
                      ) : (
                        locInv.invN +
                        " " +
                        // sta.tot.inv_type_name +
                        " " +
                        sta.tot.pay_type_name
                      )}
                  </Grid>
                  <Grid item xs={4}></Grid>

                </Grid>
                <Grid item container style={{ border: "solid 0.1px", borderColor: "#000", borderRadius: "6px", }}>
                  <Grid item xs={3} style={{
                    borderBottom: "solid 0.1px",
                    borderLeft: "solid 0.1px",
                    textAlign: "right",
                    paddingRight: "0.6rem"
                  }}>
                    {txtA.invNumr}
                  </Grid>
                  <Grid item xs={6} style={{
                    borderBottom: "solid 0.1px",
                  }}>
                    <div style={styfCenter}>{sta.tot.id}</div>
                  </Grid>
                  <Grid item xs={3} style={{
                    borderBottom: "solid 0.1px",
                    borderRight: "solid 0.1px",
                    textAlign: "left",
                    paddingLeft: "0.6rem"
                  }}>
                    {txtE.invNumr}
                  </Grid>

                  <Grid item xs={3} className={clas.BdyborBtR}
                    style={{
                      textAlign: "right",
                      paddingRight: "0.6rem",
                      borderLeft: "solid 0.1px",
                    }}>
                    {txtA.invDate}
                  </Grid>
                  <Grid item xs={6} className={clasm.minborB} >
                    <Paper className={clasm.minclr} style={styfCenter}>
                      {moment(sta.tot.date).format("YYYY/MM/DD")}
                    </Paper>
                  </Grid>
                  <Grid item xs={3} className={clas.BdyborBtL} style={{
                    textAlign: "left",
                    paddingLeft: "0.6rem",
                    borderRight: "solid 0.1px",
                  }}>
                    {txtE.invDate}
                  </Grid>

                  <Grid container item xs={12}>

                    <Grid container item xs={12}>
                      <Grid item xs={3} className={clas.BdyborBtR} style={{
                        textAlign: "right",
                        paddingRight: "0.6rem",
                        borderLeft: "solid 0.1px",
                      }}>
                        {"تاريخ التوريد"}
                      </Grid>
                      <Grid item xs={6} className={clasm.minborB}>
                        <div className={clasm.minclr} style={styfCenter}>
                          {sta.tot?.Delivery_date === null ? moment(sta.tot.date).format("YYYY/MM/DD") :
                            moment(sta.tot.Delivery_date).format("YYYY/MM/DD")}
                        </div>
                      </Grid>
                      <Grid item xs={3} className={clas.BdyborBtL} style={{
                        textAlign: "left",
                        paddingLeft: "0.6rem",
                        borderRight: "solid 0.1px",

                      }}>
                        {"Delivery Date"}
                      </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                      <Grid item xs={3} className={clas.BdyborBtR} style={{
                        textAlign: "right",
                        paddingRight: "0.6rem",
                        borderLeft: "solid 0.1px",
                      }}>
                        {"رقم الطلب"}
                      </Grid>
                      <Grid item xs={6} className={clasm.minborB}>
                        <Paper className={clasm.minclr} style={styfCenter}>
                          {sta.tot.refno}
                        </Paper>
                      </Grid>
                      <Grid item xs={3} className={clas.BdyborBtL} style={{
                        textAlign: "left",
                        paddingLeft: "0.6rem",
                        borderRight: "solid 0.1px",
                      }}>
                        {"Order No"}
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UnderHeaderComTow;
